import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { activeSlice } from '~/store'

const useActiveState = (key) => {
  const dispatch = useDispatch()

  const setActive = useCallback(
    (id) => {
      dispatch(activeSlice.setActive({ key, id }))
    },
    [dispatch, key]
  )

  const active = useSelector((state) => activeSlice.active(state, key))

  return useMemo(() => ({ active, setActive }), [active, setActive])
}

export default useActiveState
